import React from 'react';

import { FormattedMessage } from 'react-intl-next';

import Button from '@atlaskit/button';
import WarningIcon from '@atlaskit/icon/glyph/warning';
import Modal, {
  ModalBody,
  ModalFooter,
  ModalHeader,
  ModalTitle,
  ModalTransition,
} from '@atlaskit/modal-dialog';
import { colors } from '@atlaskit/theme';
import { token } from '@atlaskit/tokens';

import { useIntl } from 'src/hooks/intl';

import messages from './review-actions.i18n';
import * as styles from './review-actions.style';

type Props = {
  numOutdatedComments: number;
  onSubmit: () => Promise<void>;
  onClose: () => void;
};

export const OutdatedPendingCommentsModal = (props: Props) => {
  const intl = useIntl();
  const { numOutdatedComments, onSubmit, onClose } = props;

  const OutdatedCommentsDescription = (
    <FormattedMessage
      tagName="p"
      {...messages.outdatedCommentsDescription}
      values={{
        outdatedCommentCount: (
          <FormattedMessage
            tagName="b"
            {...messages.outdatedCommentCount}
            values={{ numOutdatedComments }}
          />
        ),
      }}
    />
  );

  return (
    <ModalTransition>
      <Modal onClose={onClose}>
        <ModalHeader>
          <ModalTitle>
            <styles.OutdatedTitle>
              <WarningIcon
                label=""
                primaryColor={token('color.icon.warning', colors.Y500)}
                size="medium"
              />
              {intl.formatMessage(messages.outdatedCommentsTitle)}
            </styles.OutdatedTitle>
          </ModalTitle>
        </ModalHeader>
        <ModalBody>{OutdatedCommentsDescription}</ModalBody>
        <ModalFooter>
          <Button appearance="subtle" onClick={onClose}>
            {intl.formatMessage(messages.cancelButton)}
          </Button>
          <Button
            appearance="warning"
            onClick={() => {
              onSubmit();
              onClose();
            }}
            autoFocus
          >
            {intl.formatMessage(messages.submitButton)}
          </Button>
        </ModalFooter>
      </Modal>
    </ModalTransition>
  );
};
